import { toolkitCollectionKeys } from "@arcadeai/ui-kit/hooks/query-keys";
import type { PartialOrgProjectScope } from "@/lib/resource-context";

export const toolkitCollectionQueryKey = (scope: PartialOrgProjectScope) =>
  toolkitCollectionKeys.collection({
    organizationId: scope.organizationId ?? undefined,
    projectId: scope.projectId ?? undefined,
  });
